/* SaffronTownKashmir&Co: staggered entry.
   Adds .stk-reveal to key elements and .is-in when they scroll into view.
   Skipped entirely for reduced-motion users. Horizontal mobile carousels are excluded
   so off-screen cards can never be stuck invisible. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var selector = '.stk-badge, .stk-review-card, .stk-faq-item, .stk-story-stat';
  if (window.innerWidth >= 750) selector += ', .stk-bsv-card';

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope.querySelectorAll(selector);
    if (!items.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) {
      if (el.classList.contains('stk-reveal')) return;
      var index = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--stk-i', Math.min(index, 5));
      el.classList.add('stk-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
